import { render, staticRenderFns } from "./home.vue?vue&type=template&id=618fa9a8&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=618fa9a8&scoped=true&lang=css&"
import style1 from "./home.vue?vue&type=style&index=1&id=618fa9a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618fa9a8",
  null
  
)

export default component.exports